export const STATE = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  QUALIFIED: 'QUALIFIED',
  DOES_NOT_QUALIFY: 'DOES_NOT_QUALIFY',
  ENROLLED: 'ENROLLED',
  OPT_OUT: 'OPTED_OUT',
};

const _STATE_DESCRIPTION_MAP = {};
_STATE_DESCRIPTION_MAP[STATE.NOT_STARTED] = 'Not Started';
_STATE_DESCRIPTION_MAP[STATE.IN_PROGRESS] = 'In Progress';
_STATE_DESCRIPTION_MAP[STATE.QUALIFIED] = 'Qualified';
_STATE_DESCRIPTION_MAP[STATE.DOES_NOT_QUALIFY] = 'Does Not Qualify';
_STATE_DESCRIPTION_MAP[STATE.ENROLLED] = 'Enrolled';
_STATE_DESCRIPTION_MAP[STATE.OPT_OUT] = 'Opted Out';

export const STATE_DESCRIPTION_MAP = _STATE_DESCRIPTION_MAP;

export default {
  STATE,
  STATE_DESCRIPTION_MAP,
};
